import { Navigate } from 'react-router-dom';
import LoginPage from 'pages/LoginPage';
import { validateAuthCookie } from 'utils/functions/authentication';

const LoginRoute = () => {
  const isUserAuthenticated = validateAuthCookie();

  return isUserAuthenticated === false ? <LoginPage /> : <Navigate to="/orders" />;
};

export default LoginRoute;
